<div class="md:container pt-4 pb-8 mx-auto text-gray-700 border-t border-gray-400 md:pt-6">
  <div class="flex flex-col justify-between px-4">
    <div class="text-sm md:text-xs font-bold"><span>Napisz do nas</span>: {{ contactUsEmail }}</div>
    <div class="text-sm md:text-xs leading-tight">
      Administratorem danych osobowych niezbędnych w procesie płatności, w tym podanych powyżej, jest BillTech Group sp.
      z o.o. z siedzibą: 00-819 Warszawa, ul. Złota 75A lok. 7, NIP 701-069-82-24, REGON 367482813, wysokość kapitału
      zakładowego: 5022,00 zł. Dane osobowe przetwarzane są w celu realizacji płatności oraz wypełnienia obowiązków
      wynikających z przepisów prawa (ustawy z dnia 19.08.2011r. o usługach płatniczych, ustawy z dnia 16.11.2000 r. o
      przeciwdziałaniu praniu pieniędzy i finansowaniu terroryzmu). Niektóre dane zostały udostępnione przez odbiorcę
      płatności i w odniesieniu do tych danych płatnik ma prawo sprzeciwu co do ich przetwarzania. Podanie danych
      osobowych jest dobrowolne, ale niezbędne do realizacji płatności. Płatnikowi przysługuje prawo dostępu do treści
      przetwarzanych danych osobowych oraz prawo ich poprawiania.
    </div>
  </div>
</div>
